<script lang="ts" setup>
    interface ProductCardOptionsProps {
        config?: IConfigurable;
        changeHoverColorOption: (option: string) => void;
        colorOptionChanged: (option: string) => void;
        colorOptionClasses?: string;
        otherOptionClasses?: string;
    }
    defineProps<ProductCardOptionsProps>();
</script>
<template>
    <template
        v-if="config"
        v-for="option in config?.options?.slice(0, 2)">
        <template v-if="option.type.includes('Color')">
            <lazy-mol-color-options
                :key="option.type"
                :options="option.values"
                :class="colorOptionClasses"
                @hover="changeHoverColorOption"
                @changed="colorOptionChanged" />
        </template>
        <template v-else>
            <lazy-mol-product-option-select
                v-if="option.canRender"
                :key="option.type"
                :option="option"
                :config="config"
                teleport
                :class="otherOptionClasses" />
        </template>
    </template>
</template>
